import { orders } from './orders';
import { onboarding } from './onboarding';
import { promoCodes } from './promoCodes';

export const reducers = {
  orders,
  promoCodes,
  onboarding,
};
